<template>
  <div class="overflow-y-hidden">
    <template
      v-if="this.isVersionMobile && getEnableMobileBottomToolbar === false"
    >
      <TopNavigationMobile></TopNavigationMobile>
    </template>
    <template
      v-if="this.isVersionMobile && getEnableMobileBottomToolbar === true"
    >
      <MobileFooterFixed></MobileFooterFixed>
    </template>
    <template v-if="getUseGenericSkinListener === true">
      <GenericSkinListener />
    </template>
    <v-container
      fluid
      class="betConsole revengeBetConsole revengeGameConsole"
      v-if="!this.isVersionMobile"
    >
      <v-row ref="HeaderHeight" v-if="getGameConsole === 'default'">
        <v-col cols="12" sm="2" md="2" class="bordered-element pl-1 pr-1">
          <Search></Search>
        </v-col>
        <v-col cols="12" sm="10" md="10" class="bordered-element pl-1 pr-1">
          <Toolbar></Toolbar>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col
          cols="12"
          sm="2"
          md="2"
          class="bordered-element pt-0 pl-1 pr-1"
          v-if="
            this.getGameConsole === 'default' && this.getLiveMode == 'preview'
          "
        >
          <div ref="LeftHeight">
            <LeftModule></LeftModule>
          </div>
        </v-col>

        <v-col
          cols="12"
          sm="2"
          md="2"
          class="bordered-element pt-0 pl-1 pr-1 container-left-module"
          v-if="
            this.getGameConsole === 'marketview' &&
            this.getLiveMode == 'preview' &&
            getUseExternalTree === false
          "
        >
          <div style="margin-bottom: 10px">
            <Search></Search>
          </div>
          <div id="leftModuleV2Container" ref="LeftHeight">
            <LeftModule></LeftModule>
            <div style="text-align: center">
              <v-btn
                class="result-btn"
                left
                @click="changeLiveMode('result')"
                :class="[this.getLiveMode == 'result' ? 'active-context' : '']"
                :title="$t('result')"
                >{{ $t('result') }}
              </v-btn>
            </div>
            <div
              style="text-align: center"
              v-if="
                quickBetEnabled === true &&
                (getUserType === '4' ||
                  getUserType === 4 ||
                  getCashier === true)
              "
            >
              <v-btn
                class="result-btn"
                left
                @click="changeLiveMode('printodds')"
                :class="[
                  this.getLiveMode == 'printodds' ? 'active-context' : '',
                ]"
                :title="$t('printodds')"
                >{{ $t('printodds') }}
              </v-btn>
            </div>
          </div>
          <div></div>
        </v-col>
        <v-col
          cols="12"
          :sm="
            this.getLiveMode == 'preview' && this.getEventsDetail.length == 0
              ? 8
              : 7
          "
          :md="
            this.getLiveMode == 'preview' && this.getEventsDetail.length == 0
              ? 8
              : 7
          "
          class="bordered-element pt-0 pl-1 pr-1"
          v-if="
            this.getLiveMode == 'preview' &&
            this.getUseModalCart == false &&
            this.getUseExternalTree == false
          "
        >
          <div ref="CenterHeight">
            <CenterModule></CenterModule>
          </div>
        </v-col>

        <div
          ref="CenterHeight"
          class="bordered-element centerWithoutTreeAndCart mt-3"
          :class="getIsCartOpen ? 'cartIsOpen' : 'cartIsNotOpen'"
          v-if="
            this.getLiveMode == 'preview' &&
            this.getUseModalCart === true &&
            this.getUseExternalTree === true
          "
        >
          <div class="flex gap-8">
            <div class="searchContainer-v2">
              <Search></Search>
            </div>
            <div class="toolbarSettingsContainer-v2">
              <toolbar-settings
                :block="false"
                :small="false"
                :full="true"
                :rounded="false"
              ></toolbar-settings>
            </div>
          </div>
          <CenterModule></CenterModule>
        </div>

        <v-col
          cols="12"
          sm="10"
          md="10"
          class="bordered-element pt-0 pl-1 pr-1"
          v-if="this.getLiveMode == 'list_events_day'"
        >
          <div ref="CenterHeight">
            <EventsDayWidget></EventsDayWidget>
          </div>
        </v-col>

        <v-col
          cols="12"
          sm="2"
          md="2"
          class="bordered-element pt-0 pl-1 pr-1"
          v-if="
            this.getLiveMode == 'detail' &&
            this.getEventsLiveDetail.length > 0 &&
            this.liveEventListPosition === 'left-component'
          "
        >
          <div ref="LeftHeight">
            <LeftModule></LeftModule>
          </div>
        </v-col>
        <v-col
          cols="12"
          :sm="
            this.getLiveMode == 'detail' && this.getEventsLiveDetail.length == 0
              ? 9
              : 7
          "
          :md="
            this.getLiveMode == 'detail' && this.getEventsLiveDetail.length == 0
              ? 9
              : 7
          "
          class="bordered-element pt-0 pl-1 pr-1"
          v-if="
            this.getLiveMode == 'detail' &&
            this.getUseModalCart === false &&
            this.getUseExternalTree === false
          "
        >
          <div ref="CenterHeight">
            <LivePreview></LivePreview>
          </div>
        </v-col>
        <div
          ref="CenterHeight"
          class="bordered-element centerWithoutTreeAndCart live mt-3"
          :class="getIsCartOpen ? 'cartIsOpen' : 'cartIsNotOpen'"
          v-if="
            this.getLiveMode == 'detail' &&
            this.getUseModalCart === true &&
            this.getUseExternalTree === true
          "
        >
          <LivePreview></LivePreview>
        </div>
        <v-col
          cols="12"
          sm="10"
          md="10"
          class="bordered-element result-detail pt-0 pl-1 pr-1"
          v-if="this.getLiveMode == 'result'"
        >
          <div ref="CenterHeight">
            <ResultDetail></ResultDetail>
          </div>
        </v-col>
        <v-col
          cols="12"
          sm="10"
          md="10"
          class="bordered-element pt-0 pl-1 pr-1"
          v-if="this.getLiveMode == 'qBet'"
        >
          <div ref="CenterHeight">
            <QuickBetDetail></QuickBetDetail>
          </div>
        </v-col>
        <v-col
          cols="12"
          sm="2"
          md="2"
          class="bordered-element pt-0 pl-1 pr-1"
          v-if="this.getLiveMode == 'qBet'"
        >
          <div ref="RightHeight">
            <RightModule></RightModule>
          </div>
        </v-col>
        <v-col
          cols="12"
          sm="10"
          md="10"
          class="bordered-element pt-0 pl-1 pr-1"
          v-if="this.getLiveMode == 'printodds'"
        >
          <div ref="CenterHeight">
            <toolbar-top-agency></toolbar-top-agency>
            <PrintOdds></PrintOdds>
          </div>
        </v-col>
        <v-col
          cols="12"
          :sm="this.getLiveMode == 'detail' ? 3 : 2"
          :md="this.getLiveMode == 'detail' ? 3 : 2"
          class="bordered-element pt-0 pl-1 pr-1"
          v-if="this.getLiveMode == 'detail' && getUseModalCart == false"
        >
          <div ref="RightHeight">
            <!--            <Statscore-->
            <!--                    v-if="!this.isMobileOnly && this.getLiveMode == 'detail' && this.getEventsLiveDetail.length > 0"></Statscore>-->
            <RightModule></RightModule>
            <!--            <LiveMatchTracker v-if="!this.isMobileOnly && this.getLiveMode == 'detail' && this.getEventsLiveDetail.length > 0"></LiveMatchTracker>-->
          </div>
        </v-col>
        <v-col
          cols="12"
          :sm="
            this.getLiveMode == 'preview' && this.getEventsDetail.length > 0
              ? 3
              : 2
          "
          :md="
            this.getLiveMode == 'preview' && this.getEventsDetail.length > 0
              ? 3
              : 2
          "
          class="bordered-element pt-0 pl-1 pr-1"
          v-if="this.getLiveMode == 'preview' && getUseModalCart == false"
        >
          <div ref="RightHeight">
            <!--            <Prematchstatscore-->
            <!--                    v-if="!this.isMobileOnly && this.getEventsDetail.length > 0"></Prematchstatscore>-->
            <RightModule></RightModule>
          </div>
        </v-col>

        <aside
          class="bordered-element pt-0 pl-0 pr-1 transitionExternalCart"
          :class="getIsCartOpen ? 'cartIsOpen' : 'cartIsNotOpen'"
          v-if="
            (this.getLiveMode == 'preview' || this.getLiveMode == 'detail') &&
            getUseModalCart === true
          "
        >
          <div
            ref="RightHeight"
            class="animate-cart-sidebar"
            v-if="getIsCartOpen"
          >
            <div class="text-right pa-4">
              <svg
                class="cursor-pointer"
                @click="closeCart()"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.7699 1.33324L6.99991 5.11324L3.22991 1.33324C2.9784 1.08173 2.63727 0.94043 2.28158 0.94043C1.92588 0.94043 1.58476 1.08173 1.33324 1.33324C1.08173 1.58476 0.94043 1.92588 0.94043 2.28158C0.94043 2.63727 1.08173 2.9784 1.33324 3.22991L5.11324 6.99991L1.33324 10.7699C1.08173 11.0214 0.94043 11.3625 0.94043 11.7182C0.94043 12.0739 1.08173 12.4151 1.33324 12.6666C1.58476 12.9181 1.92588 13.0594 2.28158 13.0594C2.63727 13.0594 2.9784 12.9181 3.22991 12.6666L6.99991 8.88658L10.7699 12.6666C11.0214 12.9181 11.3625 13.0594 11.7182 13.0594C12.0739 13.0594 12.4151 12.9181 12.6666 12.6666C12.9181 12.4151 13.0594 12.0739 13.0594 11.7182C13.0594 11.3625 12.9181 11.0214 12.6666 10.7699L8.88658 6.99991L12.6666 3.22991C12.7911 3.10537 12.8899 2.95753 12.9573 2.79481C13.0247 2.63209 13.0594 2.4577 13.0594 2.28158C13.0594 2.10545 13.0247 1.93106 12.9573 1.76834C12.8899 1.60563 12.7911 1.45778 12.6666 1.33324C12.542 1.20871 12.3942 1.10992 12.2315 1.04252C12.0688 0.97512 11.8944 0.94043 11.7182 0.94043C11.3625 0.94043 11.0214 1.08173 10.7699 1.33324Z"
                ></path>
              </svg>
            </div>
            <RightModule></RightModule>
          </div>
        </aside>
      </v-row>
      <v-row justify="center">
        <v-dialog
          ref="Dialog15"
          v-model="getModalIdle"
          persistent
          max-width="400"
          content-class="modal-on-top"
          style="background: #000000ad"
        >
          <v-card>
            <v-card-title class="text-h5">
              {{ $t('idleTitleModal') }}
            </v-card-title>
            <v-card-text> {{ $t('idleContentModal') }}</v-card-text>
            <v-card-actions class="pb-5" style="flex-direction: column">
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" @click="refreshIdle()">
                {{ $t('continue') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </v-container>
    <v-container
      fluid
      class="betConsole revengeBetConsole revengeGameConsole"
      :class="this.checkIsMobile() ? 'new-top-mobile' : 'new-top-tablet'"
      v-else-if="this.isVersionMobile"
    >
      <v-row>
        <v-col cols="12" sm="12" md="12" class="bordered-element">
          <CenterMobile></CenterMobile>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import CenterModule from '@/components/Center.vue'
import CenterMobile from '@/components/CenterMobile.vue'
import RightModule from '@/components/Right.vue'
import UserBar from '@/components/center_widgets/UserBar'
import MenuMobile from '@/components/center_widgets/MenuMobile'
import LivePreview from '@/components/center_widgets/LivePreview'
import ResultDetail from '@/components/center_widgets/ResultDetail'
import QuickBetDetail from '@/components/center_widgets/QuickBetDetail'
import PrintOdds from '@/components/center_widgets/PrintOddsV2'
import EventsDayWidget from '@/components/center_widgets/EventsDayWidget'
import { mapActions, mapGetters } from 'vuex'
import SidebarSettings from '@/components/left_widgets/SidebarSettings'
import Search from '@/components/generic/Search'
import Toolbar from '@/components/generic/Toolbar'
import { isMobileOnly, isTablet } from 'mobile-device-detect'
import BottomNavigationMobile from '@/components/center_widgets/BottomNavigationMobile'
import TopNavigationMobile from '@/components/center_widgets/TopNavigationMobile'
import LoadingSkeleton from '@/components/generic/LoadingSkeleton'
import Prematchstatscore from '@/components/right_widgets/Prematchstatscore'
import {
  checkIsMobileDevice,
  checkIsTabletDevice,
} from '../plugins/device-inspector'
import MobileFooterFixed from '@/components/generic/MobileFooterFixed'
import ToolbarTopAgency from '@/components/generic/ToolbarTopAgency'
import ToolbarSettings from '@/components/generic/ToolbarSettings.vue'

const Statscore = () => ({
  component: import('@/components/right_widgets/Statscore'),
  loading: LoadingSkeleton,
  timeout: 200,
})
const LiveMatchTracker = () => ({
  component: import('@/components/right_widgets/LiveMatchTracker'),
  loading: LoadingSkeleton,
  timeout: 200,
})
const GenericSkinListener = () => ({
  component: import('@/components/generic/GenericSkinListener'),
  loading: LoadingSkeleton,
  timeout: 200,
})

const LeftModule = () => ({
  component: import('@/components/Left'),
  loading: LoadingSkeleton,
  timeout: 200,
})

export default {
  name: 'BetConsole',
  data: () => ({
    isMobileOnly: isMobileOnly,
    isTablet: isTablet,
    scrollPosition: 0,
    headerHeight: 0,
    topConsole: 0,
    heightCenter: 0,
    heightLeft: 0,
    heightRight: 0,
    ifInDetail: false,
  }),
  components: {
    Prematchstatscore,
    MobileFooterFixed,
    BottomNavigationMobile,
    Toolbar,
    Search,
    LeftModule,
    CenterModule,
    RightModule,
    UserBar,
    SidebarSettings,
    ResultDetail,
    MenuMobile,
    LivePreview,
    Statscore,
    LiveMatchTracker,
    EventsDayWidget,
    CenterMobile,
    TopNavigationMobile,
    LoadingSkeleton,
    QuickBetDetail,
    PrintOdds,
    ToolbarTopAgency,
    ToolbarSettings,
    GenericSkinListener,
  },
  computed: {
    ...mapGetters({
      getAuthenticated: 'user/getAuthenticated',
      getLiveMode: 'odds/getLiveMode',
      getEventsLiveDetail: 'odds/getEventsLiveDetail',
      getEventsDetail: 'odds/getEventsDetail',
      getModalIdle: 'user/getModalIdle',
      getSocketEnabled: 'socket/getSocketEnabled',
      getEventStatscore: 'odds/getEventStatscore',
      getGameConsole: 'settings/getGameConsole',
      getEnableMobileBottomToolbar: 'settings/getEnableMobileBottomToolbar',
      quickBetEnabled: 'settings/quickBetEnabled',
      getCashier: 'user/getCashier',
      getUserType: 'user/getType',
      getDisableIdleUICheck: 'settings/getDisableIdleUICheck',
      getUseGenericSkinListener: 'uiConfig/useGenericSkinListener',
      getUseExternalTree: 'uiConfig/useExternalTree',
      getUseModalCart: 'uiConfig/useModalCart',
      getIsCartOpen: 'cart/getIsCartOpen',
      liveEventListPosition: 'uiConfig/liveEventListPosition',
    }),
    isVersionMobile() {
      return window.innerWidth < 1200 || window.forceMobileView === 'true'
    },
  },
  mounted() {},
  created() {},

  methods: {
    ...mapActions({
      setModalIdle: 'user/setModalIdle',
      socket_close: 'socket/socket_close',
      fixture_change_live: 'socket/SOCKET_FIXTURE_CHANGE_LIVE',
      odds_change_live: 'socket/SOCKET_ODDS_CHANGE_LIVE',
      settlement_live: 'socket/SOCKET_SETTLEMENT_LIVE',
      livescore_live: 'socket/SOCKET_LIVESCORE_LIVE',
      new_event_live: 'socket/SOCKET_NEW_EVENT_LIVE',
      place_bet_changed: 'socket/SOCKET_PLACE_BET_CHANGED',
      setLiveMode: 'odds/setLiveMode',
      setStatusQbet: 'tree/setStatusQbet',
      setIsCartOpen: 'cart/setIsCartOpen',
    }),
    closeCart() {
      this.setIsCartOpen(!this.getIsCartOpen)
    },
    checkIsMobile() {
      return checkIsMobileDevice()
    },

    checkIsTablet() {
      return checkIsTabletDevice()
    },
    refreshIdle() {
      document.body.scrollIntoView({ behavior: 'smooth' })
      window.parent.postMessage(
        {
          type: 'scrollTop',
        },
        '*'
      )
      window.location.reload()
    },
    checkIfInDetail() {
      if (this.getLiveMode == 'detail' && this.getEventsLiveDetail.length > 0) {
        this.ifInDetail = true
      }

      if (this.getLiveMode == 'preview' && this.getEventsDetail.length > 0) {
        this.ifInDetail = true
      }
    },

    changeLiveMode(mode) {
      this.setStatusQbet(false)
      this.setLiveMode({ mode: mode })
    },
  },
  onIdle() {
    document.body.scrollIntoView({ behavior: 'smooth' })
    window.parent.postMessage(
      {
        type: 'scrollTop',
      },
      '*'
    )
    if (this.getDisableIdleUICheck == false) {
      this.setModalIdle(true)
      this.socket_close()
    }
  },
  onActive() {},
}
</script>

<style>
div.v-overlay.v-overlay--active.theme--dark > div.v-overlay__scrim {
  opacity: 0.86 !important;
}
</style>
